import "./scss/App.scss";
import { useEffect, useMemo, useRef, useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";

import Main from "./pages/main";
import Loading from "./pages/Loading";
import Tutorial from "./pages/Tutorial";

import useParimutuelConnect from "./hook/useParimutuelConnect";
import { fetchBodPrices, setCoinPrices } from "./redux/coinPrices/actions";
import { fetchPlayedContests } from "./redux/contests/actions";
import { useDispatch, useSelector } from "react-redux";
import { wsConnect } from "./utils/wsConnect";
import useTokenAuth from "./hook/useTokenAuth";
import useBalance from "./hook/useBalance";
import SimulatingContent from "./components/SimulatingContent";
import { useTheme } from "./hook/useThemes";
import { usePageVisibility } from "react-page-visibility";

const App = () => {
  useBalance();
  const isVisible = usePageVisibility();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector((state: any) => state?.auth);
  const simulatingCount = auth?.simulatingCount || 0;
  const { seriesID } = useTheme();

  const [socketInterrupted, setSocketInterrupted] = useState<boolean>(false);
  const refInterVal = useRef<any>();
  const refIsVisible = useRef<boolean>(isVisible);
  refIsVisible.current = isVisible;

  useEffect(() => {
    if (window) {
      const body = document.querySelector("body");
      if (body) {
        body.classList.add("disable-scroll");
      }
    }
  }, []);

  // Add script
  useEffect(() => {
    const hotjarScript = document.createElement("script");
    hotjarScript.innerHTML = `
      (function(h,o,t,j,a,r){
        h.hj = h.hj || function() {(h.hj.q = h.hj.q || []).push(arguments)};
        h._hjSettings = { hjid: ${
          process.env.REACT_APP_HOTJAR || ""
        }, hjsv: 6 };
        a = o.getElementsByTagName('head')[0];
        r = o.createElement('script'); r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
      })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    `;
    document.head.appendChild(hotjarScript);
    const script = document.createElement("script");
    script.src = "https://cdn.usefathom.com/script.js";
    script.setAttribute("data-site", process.env.REACT_APP_FATHOM);
    script.defer = true;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
      document.head.removeChild(hotjarScript);
    };
  }, []);

  useParimutuelConnect({
    onOpen: () => setSocketInterrupted(false),
    onReconnect: () => setSocketInterrupted(true),
    seriesID,
  });

  useEffect(
    () => {
      let ws;
      if (auth?.token && seriesID) {
        dispatch<any>(fetchPlayedContests(auth, seriesID));
        dispatch<any>(fetchBodPrices());
        // get coin
        ws = wsConnect(process.env.REACT_APP_TICKING_PRICE_WS, {
          retry: Infinity,
          onMessage: (evt) => dispatch<any>(setCoinPrices(evt.data)),
        });
      }
      navigate(`/${window.location.search}`);
      return () => ws?.close();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [auth?.token, auth?.subscriptionKey, seriesID]
  );

  // check tab is active
  if (!refIsVisible.current) {
    refInterVal.current = setInterval(() => {
      const startInActive = Number(
        sessionStorage.getItem("start_inActive") || 0
      );
      if (!startInActive) {
        sessionStorage.setItem("start_inActive", `${new Date().getTime()}`);
        return;
      }
      if (refIsVisible.current) {
        window.clearInterval(refInterVal.current);
        sessionStorage.removeItem("start_inActive");
        return;
      }
      const currentTime = new Date().getTime();
      console.log("isVisible",currentTime - startInActive)
      if (currentTime - startInActive > 3600 * 1000) {
        window.location.reload();
      }
    }, 60000);
  }

  if (refIsVisible.current) {
    window.clearInterval(refInterVal.current);
    sessionStorage.removeItem("start_inActive");
  }

  if (socketInterrupted) {
    return <div className="block-modal">Connection lost, reconnecting...</div>;
  }

  return (
    <div className="app">
      {simulatingCount >= 5 && <SimulatingContent />}
      {simulatingCount < 5 && (
        <Routes>
          {/* <Route path="/loading" element={<Loading />} /> */}
          <Route path="/tutorial" element={<Tutorial />} />
          <Route path="*" element={<Main />} />
        </Routes>
      )}
    </div>
  );
};

const TokenAuth = () => {
  const auth = useTokenAuth();

  return auth?.token && auth?.subscriptionKey ? (
    <App />
  ) : (
    <div className="app">Unauthorized</div>
  );
};

export default TokenAuth;
